import configData from "./configData.json";

// export const msalConfig = {
//   auth: {
//     clientId: configData.MICROSOFT_CLIENT_ID,
//     redirectUri: configData.MICROSOFT_URL,
//     authority:
//       "https://login.microsoftonline.com/luckiwipmoutlook.onmicrosoft.com",
//   },
//   cache: {
//     cacheLocation: "sessionStorage",
//     storeAuthStateInCookie: true,
//   },
// };

// export const loginRequest = {
//   scopes: [],
// };

//imported in index.js
export const msalConfig = {
  auth: {
    clientId: "a1dc9dd3-f471-4586-b327-71001f4c7388",
    authority: "https://login.microsoftonline.com/common",
    // authority:
    // redirectUri: "https://www.luckiwi.com/microsoftoauth/",
    // authority: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
    // "https://login.microsoftonline.com/7a8a5786-ccaf-4407-b765-47b5d5414657/oauth2/v2.0/authorize",
    // redirectUri: "http://localhost:3000/microsoftoauth/",
    response_type: "code",
    response_mode: "query",
    redirectUri: "https://app.luckiwi.com/microsoftoauth/",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "User.Read", "email"], // so this is an open id exchange
  // scopes: ["User.Read"],
  prompt: "select_account",
};

// export const msalConfigCalendar = {
//   auth: {
//     clientId: "a1dc9dd3-f471-4586-b327-71001f4c7388",
//     authority: "https://login.microsoftonline.com/common",
//     redirectUri: "http://localhost:3000/microsoftOauthCalendar/",
//   },
//   cache: {
//     cacheLocation: "sessionStorage",
//     storeAuthStateInCookie: false,
//   },
// };

export const calendarRequest = {
  scopes: [
    "openid",
    "profile",
    "User.Read",
    "email",
    "Calendars.ReadWrite",
    "offline_access",
  ], // so this is an open id exchange
  // scopes: ["User.Read"],
  prompt: "select_account",
};

// export const graphConfig = {
//   graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
// };
